import React, { Suspense } from 'react'
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css'
import { LoginBackground } from './LoginBackground'
import { diagnosticsLogger } from 'logger/diagnosticsLogger'

const OktaLoginForm = React.lazy(() => import(/* webpackChunkName: "okta-login" */ './OktaLoginForm'))

export const OktaLoginFormLazy: React.FunctionComponent = props => {
  diagnosticsLogger.log('LoginBackground potentially being rendered awaiting OktaLoginForm to import')
  return (
    <Suspense fallback={<LoginBackground showSpinner={true} />}>
      <OktaLoginForm {...props} />
    </Suspense>
  )
}
